import axios from 'axios'
import { showNotify } from 'vant'
import { STORAGE_TOKEN_KEY, STORAGE_LANG_KEY, STORAGE_USER_INFO_KEY } from '@/stores/mutation-type'
import md5 from 'crypto-js/md5'
import { closeWebSocket } from '@/utils/websocketService'
import { errorToast } from '@/utils/toast'
import router from '@/router'
import { useUserStore } from '@/stores'
import { useEventBus } from '@vueuse/core'
import { locale } from '@/utils/i18n'

// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: import.meta.env.VITE_APP_API_BASE_URL,
  timeout: 10000, // 请求超时时间
})
const locales = {
  'pt-BR': 'pt-pt',
  'en-US': 'en-us',
  'vi-VN': 'vi-vn',
}
// 签名
function generateSignature(params, secretKey, expireTime) {
  // 1. 参数排序
  const sortedParams = Object.keys(params)
    .sort()
    .map((key) => `${key}=${params[key]}`)
    .join(':')

  // 2. 拼接固定字符串
  const baseString = `${sortedParams}bjsignature`

  // 3. 添加密钥和时间戳
  const signString = `${secretKey}${expireTime}${baseString}` //  约定的secret 和 当前时间戳 expire 和

  // console.log('signString:', signString)

  // 4. 生成 MD5 签名
  return md5(signString)
}
// 替换的原函数requestHandler
let localConfigPromise = null

function getLocalConfig() {
  // 防止并发请求同时 fetch
  if (!localConfigPromise) {
    localConfigPromise = fetch('/config.json')
      .then((res) => res.json())
      .then((config) => {
        localStorage.setItem('localConfig', JSON.stringify(config))
        return config
      })
      .catch((err) => {
        localConfigPromise = null // 失败后允许重试
        throw err
      })
  }
  return localConfigPromise
}
// 请求拦截器
async function requestHandler(config) {
  try {
    const savedToken = localStorage.getItem(STORAGE_TOKEN_KEY)
    const expireTime = Date.now()

    let localConfig

    // 1️⃣ 先尝试同步读取
    const cached = localStorage.getItem('localConfig')
    if (cached) {
      localConfig = JSON.parse(cached)
    }

    // 2️⃣ 没有 appid 再兜底
    if (!localConfig?.appid) {
      localConfig = await getLocalConfig()
    }

    const appid = localConfig?.appid
    if (!appid) {
      throw new Error('appid is required 缺失appid')
    }

    let params = {}

    if (config.method === 'get' && config.params) {
      params = { ...config.params }
    } else if (['post', 'put', 'patch'].includes(config.method) && config.data) {
      params = { ...config.data }
    }

    const secretKey = '78e36ersfdhjhdjf82345@#!23SD14F'
    const signature = generateSignature(params, secretKey, expireTime)

    config.headers['expire'] = expireTime
    config.headers['sign'] = signature

    if (savedToken) {
      config.headers['token'] = savedToken
    }

    config.headers['Accept-Language'] = locales[locale.value]
    config.headers['appid'] = btoa(appid)
  } catch (error) {
    console.error('requestHandler error:', error)
    return Promise.reject(error)
  }

  return config
}
// // 请求拦截器
// function requestHandler(config) {
//   try {
//     // console.log('config1111:', config)

//     const savedToken = localStorage.getItem(STORAGE_TOKEN_KEY)
//     const lang = localStorage.getItem(STORAGE_LANG_KEY)
//     const appid = JSON.parse(localStorage.getItem('localConfig'))?.appid
//     const expireTime = Date.now()

//     // 提取请求参数
//     let params = {}
//     if (config.method === 'get' && config.params) {
//       params = { ...config.params }
//     } else if (['post', 'put', 'patch'].includes(config.method) && config.data) {
//       params = { ...config.data }
//     }

//     // 生成签名
//     const secretKey = '78e36ersfdhjhdjf82345@#!23SD14F' // 替换为实际的密钥,可优化密钥存放方式
//     const signature = generateSignature(params, secretKey, expireTime)

//     // 将签名和时间戳添加到请求头
//     config.headers['expire'] = expireTime // expire当前时间戳
//     config.headers['sign'] = signature
//     // config.headers['testUid'] = '10000000'

//     // 如果 token 存在
//     if (savedToken) config.headers['token'] = savedToken // config.headers['token'] = '5cd59d5daa4353dedbc756742483f2b7'

//     // if (lang)
//     config.headers['Accept-Language'] = 'pt-pt' // pt-pt  en-us  zh-cn   // 旧的时pt-BR

//     if (appid) config.headers['appid'] = btoa(appid)
//     // console.log('config.headers:', config.headers)
//   } catch (error) {
//     console.log('requestHandler error:', error)
//     // window.location.href('/')
//   }
//   return config
// }

// 异常拦截处理器 -  http请求 状态码
function errorHandler(error) {
  if (error.response) {
    const { data = {}, status, message } = error.response
    // 403 无权限
    if (status === 403) {
      // showNotify({ type: 'danger', message: (data && data.message) || message, })
      errorToast((data && data.message) || message)
    }
    // 401 未登录/未授权
    if (status === 401 && data.result && data.result.isLogin) {
      // showNotify({ type: 'danger', message: 'Authorization verification failed', })
      errorToast('Authorization verification failed 401')
      // 如果你需要直接跳转登录页面 需要后端确定
      // location.replace(loginRoutePath)
    }
    //
    if (status === 500) {
      errorToast(message || 'Request failed')
    }

    if (status === 404) {
      errorToast(message || '404 api not found')
    }

    if (status === 400) {
      errorToast(message || error.message || '400 error')
    }
  }

  if (error.code === 'ECONNABORTED' || error.message === 'timeout of 6000ms exceeded') {
    errorToast('A solicitação expirou...') //请求超时
    // logout()
  }

  return Promise.reject(error)
}

// Add a request interceptor
request.interceptors.request.use(requestHandler, errorHandler)

// 响应拦截器  业务级别的处理
function responseHandler(response) {
  // console.log('API responseHandler:', response)
  const { status, data } = response
  // HTTP 状态码错误
  if (status !== 200) {
    // showNotify({  message: msg, type: 'error', })
    errorToast(data.msg)
    return Promise.reject(new Error(data?.msg || 'Request failed'))
  }
  // 签名问题 临时补充注释提示
  if (status == 200 && data.code == 1011) {
    return response.data
  }
  if (status == 200 && data.code == 1031) {
    // console.log('API responseHandler: 1031', response)
    const userStore = useUserStore()
    userStore.handleLogout()
    return
  }
  // 账号封禁
  if (status == 200 && data.code == 1038) {
    // console.log('API responseHandler: 1038', response)
    errorToast(data.msg || '1038 error')
    const userStore = useUserStore()
    userStore.handleLogout()
    return
  }
  // 只是说明接口数据没有变动 直接用缓存数据 不需要处理(数据无需加载...)
  if (status == 200 && data?.code == 304) {
    return response.data
  }
  // 失败码
  if (status == 200 && data?.code !== 1) {
    errorToast(data?.msg || 'Request failed')
    return Promise.reject(new Error(data?.msg || 'Request failed'))
  }
  // 成功码
  if (status == 200 && data?.code == 1) {
    return response.data
  }
}

// Add a response interceptor
request.interceptors.response.use(responseHandler, errorHandler)

export default request
